var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 0.992188C4.9751 0.992188 0.850098 5.04219 0.850098 10.1422C0.850098 17.9422 10.0001 23.7922 10.0001 23.7922C10.0001 23.7922 19.1501 18.3922 19.1501 10.1422C19.1501 5.04219 15.0251 0.992188 10.0001 0.992188ZM10.0001 14.5672C7.5251 14.5672 5.5751 12.5422 5.5751 10.1422C5.5751 7.74219 7.6001 5.71719 10.0001 5.71719C12.4001 5.71719 14.4251 7.74219 14.4251 10.1422C14.4251 12.5422 12.4751 14.5672 10.0001 14.5672Z",
    fill: "url(#paint0_linear_6950_4171)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6950_4171",
    x1: 3.48455,
    y1: 17.4263,
    x2: 16.6702,
    y2: 4.24051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009377"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin3);
export default __webpack_public_path__ + "static/media/pin-3.d88f3624003028da9c24bbe713ee9701.svg";
export { ForwardRef as ReactComponent };